import { useEffect, useState } from 'react';

interface IGetGeocode {
  branchPhone: string; 
  branchStreet: string;
  branchCityStateZip: string;
}

const useGetGeocode = ({ branchStreet, branchCityStateZip }: IGetGeocode) => {
  const [latLng, setLatLng] = useState<{lat: number, lng: number} | null>(null);

  useEffect(() => {
    if (!latLng) {
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ 
        address: [branchStreet, branchCityStateZip].join(' '),
       }, function (results) {
        const lat = results?.[0].geometry.location.lat();
        const lng = results?.[0].geometry.location.lng();

        if (lat && lng) {
          setLatLng({ lat, lng });
        };
      });
    };
  }, [])
  
  const getDirection = async () => {
    const encodedAddressStreet = encodeURIComponent([branchStreet, branchCityStateZip].join(' '));
    const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddressStreet}`;

    window.open(mapsUrl, '_blank');
  };

  return {
    getDirection,
    latLng,
  }
}

export default useGetGeocode;
